import { _BaseSectionButtonData, ISectionButtonData, sectionButtonData } from "./_base-section-button"

export class SectionButtonEdit 
    extends _BaseSectionButtonData
{
    protected constructor(buttonData?: ISectionButtonData){
        super(buttonData);

        this[sectionButtonData.disabled] = false;
        this[sectionButtonData.hide] = null;
    }

    static create(buttonData?: ISectionButtonData) : ISectionButtonData | null {
        return !!buttonData ? new SectionButtonEdit(buttonData) : null;
    }
}
